import * as global from '../../services/global.service';
import { DatePipe } from '@angular/common';
import { Form, FormGroup, ValidationErrors } from '@angular/forms';
import { Pagination } from '../../models/pagination';
import { Plan } from '../../models/plan';

const datePipe = new DatePipe('en-US');

export class Utils {
  public static buildImageUrl( image: string): string {
    return global.CDN_URL + image;
  }

  public static toDate( value: string): Date {
    return new Date( datePipe.transform( value, 'yyyy-MM-dd'));
  }

  public static removeFromArray( array: any[], item: any) {
    array.splice( array.indexOf( item), 1);
  }

  public static addToArray( array: any[], item: any) {
    array.push(item);
  }

  /**
   * Convierte el nombre de un campo en camelCase a "Camel Case".
   *
   * @example
   *    descripcionCorta -> "Descripcion Corta"
   */
  public static toDisplayFieldName( name: string): string {
    return this.capitalize( name)
                .split( /(?=[A-Z])/)
                .join( ' ');
  }

  public static capitalize( value: string): string {
    return value[0].toUpperCase() + value.substring( 1);
  }

  public static getFirstNotNull( list: Function[]): string|null {
    for (const fn of list) {
      const result = fn();

      if (result) {
        return result;
      }
    }

    return null;
  }

  public static getFirstNotNullAsync( list: Function[]): Promise<string|null> {
    for (const fn of list) {
      const result = fn();

      if (result) {
        if (Utils.isPromise( result)) {
          return result;
        } else {
          return Promise.resolve( result);
        }
      }
    }

    return Promise.resolve( null);
  }

  /**
   * Retrieves the first validation error message from all controls within a given form.
   * It iterates through the controls in the form, checking for validation errors and returns
   * a descriptive error message for the first encountered error.
   *
   * @param {FormGroup} form - The form group containing form controls to validate.
   * @param {string} errorMessage - The base error message to use for required field validation errors.
   * @return {string|null} A descriptive error message for the first validation error found, or null if no errors are present.
   */
  public static getFirstFormAllErrors( form: FormGroup, errorMessage: string): string|null {
    for (const fieldName of Object.keys( form.controls)) {
      const control = form.get(fieldName);
      if (!control) {
        continue;
      }
      const errors: ValidationErrors = control.errors;
      // console.log('Utils.getFirstFormAllErrors errors', fieldName, errors);

      if (errors) {
        // Se replica la lógica de `CustomValidators.getErrorMessage` para varios tipos de error.

        // 1. Error personalizado 'minCustom'
        if (errors.minCustom && errors.minCustom.message) {
          return errors.minCustom.message;
        }

        // 2. Error estándar 'min'
        if (errors.min) {
          return `El valor para ${Utils.toDisplayFieldName(fieldName)} debe ser mayor o igual a ${errors.min.requiredValue}`;
        }

        // 3. Error estándar 'required'
        if (errors.required) {
          return errorMessage + Utils.toDisplayFieldName(fieldName);
        }

        // 4. Fallback para otros errores, devolviendo la clave del primer error encontrado.
        const errorKey = Object.keys(errors)[0];
        if (errorKey) {
          return `El campo ${Utils.toDisplayFieldName(fieldName)} tiene un error de validación (${errorKey}).`;
        }
      }
    }

    return null;
  }

  public static getFirstFormRequiredErrors( form: FormGroup, errorMessage: string): string|null {
    for (const fieldName of Object.keys( form.controls)) {
      const control = form.get(fieldName);
      if (!control) {
        continue;
      }
      const errors: ValidationErrors = control.errors;
      // console.log('Utils.getFirstFormAllErrors errors', fieldName, errors);

      // Error estándar 'required' (sin fallback para otros errores)
      if (errors && errors.required) {
        return errorMessage + Utils.toDisplayFieldName(fieldName);
      }
    }

    return null;
  }

  public static getFirstFormError( form: FormGroup, errorMessage: string): string|null {
    for (const fieldName of Object.keys( form.controls)) {
      const errors: ValidationErrors = form.get( fieldName).errors;

      if (errors !== null) {
        for (const key of Object.keys( errors)) {
          if (key === 'required' && errors[key]) {
            return errorMessage + Utils.toDisplayFieldName( fieldName);
          } else {
            // Returns nothing
            // return key;
          }
        }
      }
    }

    return null;
  }

  public static getFirstFormErrorAsync( form: FormGroup, errorMessage: string): Promise<string|null> {
    return Promise.resolve( Utils.getFirstFormError( form, errorMessage));
  }

  public static isPresent( value: any): boolean {
    return value !== null && typeof value !== 'undefined';
  }

  public static isBlank( value?: string): boolean {
    return !Utils.isPresent( value) || value.trim().length === 0;
  }

  public static anyIsBlank( items: Array<any>): boolean {
    return items.some( Utils.isBlank);
  }

  public static isPromise( value?: any): boolean {
    return typeof value !== 'undefined' && value !== null && 'then' in value;
  }

  public static calculatePage(index: number, pagination: Pagination) {

    const total = pagination['links'].length - 1;
    const currentPage = pagination.currentPage;

    // Anterior
    if ( index === 0 && index !== total  ) {
      return currentPage - 1;
    }

    // Siguiente
    if ( total === index && index !== 0 ) {
      return currentPage + 1;
    }

    // Page
    if ( index > 0 && index < total) {
      return Number(pagination['links'][index].label);
    }
  }

  public static getPlan(id): Plan {

    if ( id === 1 ) {
      return {
        id : 1,
        titulo : 'BASIC',
        moMinimo : 120
      };
    }

    if ( id === 2 ) {
      return {
        id : 2,
        titulo : 'PRO',
        moMinimo : 120
      };
    }

  }
}
